export const mapDailyReportResultToProgress = (result: any) => {
	const userCount = Number(result?.userCount || 0)
	const activityCount = Number(result?.activityCount || 0)
	const messageCount = Number(result?.messageCount || 0)
	const gitCommitCount = Number(result?.gitCommitCount || 0)
	const jiraEventCount = Number(result?.jiraEventCount || 0)
	const deliveryStatus = result?.deliveryStatus || 'success'
	const deliverySuccessCount = Number(result?.deliverySuccessCount || 0)
	const deliveryFailureCount = Number(result?.deliveryFailureCount || 0)
	const deliveryReceipts = Array.isArray(result?.deliveryReceipts)
		? result.deliveryReceipts
		: []
	const deliveryFailures = Array.isArray(result?.deliveryFailures)
		? result.deliveryFailures
		: []
	const matchedUsers = Array.isArray(result?.matchedUsers)
		? result.matchedUsers
		: []
	const requestedUsers = Array.isArray(result?.requestedUsers)
		? result.requestedUsers
		: []
	const userText = requestedUsers.length
		? ` | Matched users: ${matchedUsers.length ? matchedUsers.join(', ') : 'none'}`
		: ''
	const receiptText = deliveryReceipts.length
		? ` | Confirmed: ${deliveryReceipts
				.slice(0, 10)
				.map(
					(item) =>
						`${item.destination}(${item.chatId}/topic ${item.messageThreadId}, message ${item.telegramMessageId || '-'})`,
				)
				.join(', ')}${
				deliveryReceipts.length > 10
					? `, +${deliveryReceipts.length - 10} more`
					: ''
			}`
		: ''
	const failureText = deliveryFailures.length
		? ` | Errors: ${deliveryFailures
				.slice(0, 10)
				.map(
					(item) =>
						`${item.destination}(${item.chatId}/topic ${item.messageThreadId}): ${item.error}`,
				)
				.join('; ')}${
				deliveryFailures.length > 10
					? `; +${deliveryFailures.length - 10} more`
					: ''
			}`
		: ''
	const status =
		deliveryStatus === 'partial'
			? 'warning'
			: deliveryStatus === 'failed'
				? 'failed'
				: 'completed'

	return {
		total: userCount,
		processed: activityCount,
		updated:
			result?.deliverySuccessCount === undefined
				? messageCount
				: deliverySuccessCount,
		skipped: 0,
		failed: deliveryFailureCount,
		percent: 100,
		status,
		message:
			`Date: ${result?.date || '-'} | Sent: ${
				result?.sent ? 'yes' : 'no'
			} | Delivery: ${deliveryStatus} (${deliverySuccessCount} success, ${deliveryFailureCount} failed) | Git commits: ${gitCommitCount} | Jira events: ${jiraEventCount} | Messages: ${messageCount}${userText}${receiptText}${failureText}`,
	}
}
